var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.menu.items.length
    ? _c(
        "div",
        {
          ref: "menuRef",
          staticClass: "context-menu-wrapper",
          style: _setup.menuStyle,
          attrs: { id: _setup.CONTEXT_MENU_ID },
        },
        _vm._l(_setup.menu.items, function (item, idx) {
          return _c(
            "div",
            {
              key: `context-item-${idx}`,
              class: { "border-bottom": item.isDivider },
            },
            [
              !item.isDivider
                ? _c(
                    "button",
                    {
                      staticClass: "menu-item",
                      class: { "d-none": item.hidden },
                      on: {
                        click: function ($event) {
                          return _setup.handleItemClick(item)
                        },
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-2",
                        attrs: { icon: item.icon },
                      }),
                      _vm._v(
                        "\n            " + _vm._s(item.label) + "\n            "
                      ),
                      item.hint?.length
                        ? _c("span", { staticClass: "hint" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(item.hint) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }